import request from '../../../services/request';
import type { MenuPermissionItem } from '../../../utils/menuPermissions';

// const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/v1';

export interface LoginCredentials {
    email: string;
    password: string;
}

export interface LoginResponse {
    access: string;
    refresh: string;
    user: {
        id: string;
        email: string;
        first_name: string;
        last_name: string;
        full_name: string;
        role: 1 | 2 | 3;
        roles: number[];
        role_display: string;
        is_active: boolean;
        is_superuser?: boolean;
        user_permissions?: number[];
        menu_items?: number[];
        effective_menu_items?: MenuPermissionItem[];
        last_login?: string;
        profile_image?: string | null;
        profile_image_url?: string | null;
        notes?: string | null;
    };
}

export interface RefreshTokenResponse {
    access: string;
}

export const authAPI = {
    login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
        return await request.post(`/v1/auth/token/`, credentials);

    },

    refreshToken: async (refreshToken: string): Promise<RefreshTokenResponse> => {
        return await request.post(`/v1/auth/token/refresh/`, {
            refresh: refreshToken,
        });

    },

    logout: async (refreshToken: string): Promise<void> => {
        await request.post(`/v1/users/logout/`, {
            refresh: refreshToken,
        });
    },

    validateToken: async (): Promise<boolean> => {
        const token = localStorage.getItem('access_token');
        try {
            // Make a simple authenticated request to validate the token
            await request.get(`/v1/users/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return true;
        } catch (error) {
            return false;
        }
    },

    getCurrentUser: async (): Promise<LoginResponse['user']> => {
        const token = localStorage.getItem('access_token');
        return await request.get(`/v1/users/me/`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

    },

    googleAuth: async (idToken: string): Promise<LoginResponse> => {
        return await request.post(`/v1/auth/google/`, { id_token: idToken });
    },

    microsoftAuth: async (idToken: string): Promise<LoginResponse> => {
        return await request.post(`/v1/auth/microsoft/`, { id_token: idToken });
    },

    updateProfileImage: async (userId: string, file: File): Promise<LoginResponse['user']> => {
        const formData = new FormData();
        formData.append('profile_image', file);

        return await request.patch(`/v1/users/${userId}/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
};
